"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveError = exports.configMoment = exports.validateTime = exports.validateDate = exports.ErrorKeys = exports.handleSelection = exports.genClasses = exports.updateValue = exports.genFormat = exports.getMonth = exports.shimLocals = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
function shimLocals(lng) {
    return lng.includes('zh') ? 'zh-cn' : lng;
}
exports.shimLocals = shimLocals;
function getMonth(date) {
    return date.clone().startOf('month');
}
exports.getMonth = getMonth;
function genFormat(lng, displayFormat) {
    return function (value) {
        var date = value ? value.clone() : moment_timezone_1.default();
        var formats = displayFormat ? displayFormat.split(',') : [];
        switch (formats.length) {
            case 1:
                formats.push(moment_timezone_1.default().locale(lng).localeData().longDateFormat('LT'));
                break;
            case 2:
                formats = formats.map(function (format) { return format.trim(); });
                break;
            default:
                formats = [moment_timezone_1.default().locale(lng).localeData().longDateFormat('L'), moment_timezone_1.default().locale(lng).localeData().longDateFormat('LT')];
                break;
        }
        var dateFormat = formats[0], timeFormat = formats[1];
        var fullFormat = dateFormat + ", " + timeFormat;
        return {
            formattedDate: date.format(dateFormat),
            formattedTime: date.format(timeFormat),
            formattedFull: date.format(fullFormat),
            dateFormat: dateFormat,
            timeFormat: timeFormat,
            fullFormat: fullFormat,
        };
    };
}
exports.genFormat = genFormat;
function updateValue(_a) {
    var value = _a.value, date = _a.date, unit = _a.unit;
    var clone;
    if (!value) {
        clone = date.clone();
    }
    else {
        clone = value.clone();
    }
    if (unit === 'day') {
        clone.set({
            date: date.get('date'),
            month: date.get('month'),
            year: date.get('year'),
        });
    }
    else {
        clone.set({
            hour: date.get('hour'),
            minute: date.get('minute'),
        });
    }
    return clone;
}
exports.updateValue = updateValue;
function genClasses(_a) {
    var className = _a.className, fluid = _a.fluid, open = _a.open, openUp = _a.openUp, range = _a.range, viewType = _a.viewType;
    var classes = 'ui date-picker-input';
    if (className) {
        classes += ' ' + className;
    }
    if (fluid) {
        classes += ' fluid';
    }
    if (open) {
        classes += ' open';
    }
    if (range) {
        classes += ' is-range';
    }
    if (viewType === 'compact') {
        classes += ' compact';
    }
    if (openUp) {
        classes += ' open-up';
    }
    return classes;
}
exports.genClasses = genClasses;
function handleSelection(_a) {
    var onChange = _a.onChange, onTextChange = _a.onTextChange, onRangeSelect = _a.onRangeSelect, text = _a.text, date = _a.date, to = _a.to, from = _a.from, error = _a.error;
    if (onTextChange) {
        onTextChange(text, error);
    }
    if (onChange && date) {
        onChange(date.toDate(), {
            utc: date.valueOf(),
            iso: date.toISOString(),
            dateString: date.format(),
        });
    }
    if (onRangeSelect) {
        onRangeSelect({
            to: to ? to.toDate() : undefined,
            from: from ? from.toDate() : undefined,
        }, {
            utc: {
                from: from ? from.valueOf() : undefined,
                to: to ? to.valueOf() : undefined,
            },
            iso: {
                from: from ? from.toISOString() : undefined,
                to: to ? to.toISOString() : undefined,
            },
            dateString: {
                from: from ? from.format() : undefined,
                to: to ? to.format() : undefined,
            },
        });
    }
}
exports.handleSelection = handleSelection;
exports.ErrorKeys = {
    invalidDate: 'invalid date',
    invalidRange: 'invalid range',
    pastDatesDisabled: 'Past dates are disabled',
    futureDatesDisabled: 'Future dates are disabled',
    weekendDatesDisabled: 'Weekend dates are disabled',
    invalidTime: 'invalid time',
    pastTimesDisabled: 'Past times are disabled',
    futureTimesDisabled: 'Future times are disabled',
};
function validateDate(_a) {
    var value = _a.value, disablePast = _a.disablePast, disableFuture = _a.disableFuture, disableWeekends = _a.disableWeekends, format = _a.format;
    var range = value.split('-');
    var from = range[0], to = range[1];
    var error = '';
    var date;
    var now;
    if (range.length === 2) {
        var validateDateString = function (date) {
            return validateDate({
                value: date.trim(),
                disableFuture: disableFuture,
                disablePast: disablePast,
                disableWeekends: disableWeekends,
                format: format,
            });
        };
        error = validateDateString(from) || validateDateString(to);
        if (!error && moment_timezone_1.default(from, format).isAfter(moment_timezone_1.default(to, format))) {
            error = exports.ErrorKeys.invalidRange;
        }
    }
    else {
        date = moment_timezone_1.default(value, format);
        now = moment_timezone_1.default();
        if (!date.isValid()) {
            error = exports.ErrorKeys.invalidDate;
        }
        else if (date.isBefore(now) && disablePast) {
            error = exports.ErrorKeys.pastDatesDisabled;
        }
        else if (date.isAfter(now) && disableFuture) {
            error = exports.ErrorKeys.futureDatesDisabled;
        }
        else if ([0, 6].includes(date.get('day')) && disableWeekends) {
            error = exports.ErrorKeys.weekendDatesDisabled;
        }
        if (value === '') {
            error = '';
        }
    }
    return error;
}
exports.validateDate = validateDate;
function validateTime(_a) {
    var value = _a.value, disablePast = _a.disablePast, disableFuture = _a.disableFuture;
    var now = moment_timezone_1.default();
    var datetime = moment_timezone_1.default(value);
    var error = '';
    if (!datetime.isValid()) {
        error = exports.ErrorKeys.invalidTime;
    }
    else {
        if (datetime.isBefore(now) && disablePast) {
            error = exports.ErrorKeys.pastTimesDisabled;
        }
        else if (datetime.isAfter(now) && disableFuture) {
            error = exports.ErrorKeys.futureTimesDisabled;
        }
    }
    return error;
}
exports.validateTime = validateTime;
function configMoment(lng, timezone, format) {
    if (format === void 0) { format = 'L, LT'; }
    var tz = timezone || moment_timezone_1.default.tz.guess();
    return function (value) {
        var newMoment;
        if (value && moment_timezone_1.default(value, format).isValid()) {
            newMoment = moment_timezone_1.default(value, format).locale(lng).tz(tz);
        }
        else {
            newMoment = moment_timezone_1.default(moment_timezone_1.default(), format).locale(lng).tz(tz);
        }
        return newMoment;
    };
}
exports.configMoment = configMoment;
function resolveError(errorKey, t, i18nErrors) {
    if (!errorKey) {
        return '';
    }
    var propKey = Object.keys(exports.ErrorKeys).find(function (k) { return exports.ErrorKeys[k] === errorKey; });
    if (propKey && (i18nErrors === null || i18nErrors === void 0 ? void 0 : i18nErrors[propKey])) {
        return i18nErrors[propKey];
    }
    return t(errorKey);
}
exports.resolveError = resolveError;
